import { MapStyle } from "../../../../shared/types";
const standardMapStyles = showLabels => [{
  featureType: "all",
  elementType: "labels",
  stylers: [{
    visibility: showLabels || "on"
  }]
}];
const darkMapStyles = showLabels => [{
  featureType: "all",
  elementType: "labels",
  stylers: [{
    visibility: showLabels || "on"
  }]
}, {
  elementType: "geometry",
  stylers: [{
    color: "#212121"
  }]
}, {
  elementType: "labels.text.fill",
  stylers: [{
    color: "#757575"
  }]
}, {
  elementType: "labels.text.stroke",
  stylers: [{
    color: "#212121"
  }]
}, {
  featureType: "administrative",
  elementType: "geometry",
  stylers: [{
    color: "#757575"
  }]
}, {
  featureType: "administrative.country",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#9e9e9e"
  }]
}, {
  featureType: "administrative.land_parcel",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "administrative.locality",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#bdbdbd"
  }]
}, {
  featureType: "poi",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#757575"
  }]
}, {
  featureType: "poi.park",
  elementType: "geometry",
  stylers: [{
    color: "#181818"
  }]
}, {
  featureType: "poi.park",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#616161"
  }]
}, {
  featureType: "poi.park",
  elementType: "labels.text.stroke",
  stylers: [{
    color: "#1b1b1b"
  }]
}, {
  featureType: "road",
  elementType: "geometry.fill",
  stylers: [{
    color: "#2c2c2c"
  }]
}, {
  featureType: "road",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#8a8a8a"
  }]
}, {
  featureType: "road.arterial",
  elementType: "geometry",
  stylers: [{
    color: "#373737"
  }]
}, {
  featureType: "road.highway",
  elementType: "geometry",
  stylers: [{
    color: "#3c3c3c"
  }]
}, {
  featureType: "road.highway.controlled_access",
  elementType: "geometry",
  stylers: [{
    color: "#4e4e4e"
  }]
}, {
  featureType: "road.local",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#616161"
  }]
}, {
  featureType: "transit",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#757575"
  }]
}, {
  featureType: "water",
  elementType: "geometry",
  stylers: [{
    color: "#000000"
  }]
}, {
  featureType: "water",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#3d3d3d"
  }]
}];
const lightMapStyles = showLabels => [{
  featureType: "all",
  elementType: "all",
  stylers: [{
    saturation: "-100"
  }]
}, {
  featureType: "all",
  elementType: "labels",
  stylers: [{
    visibility: showLabels || "on"
  }]
}];
const naturalBlueMapStyles = showLabels => [{
  featureType: "all",
  elementType: "labels",
  stylers: [{
    visibility: showLabels || "on"
  }]
}, {
  featureType: "all",
  elementType: "labels.text.fill",
  stylers: [{
    color: "#ffffff"
  }]
}, {
  featureType: "all",
  elementType: "labels.text.stroke",
  stylers: [{
    color: "#3e606f"
  }, {
    weight: 2
  }, {
    gamma: 0.84
  }, {
    lightness: "0"
  }]
}, {
  featureType: "administrative",
  elementType: "geometry",
  stylers: [{
    weight: 0.6
  }, {
    color: "#1a3541"
  }]
}, {
  featureType: "landscape",
  elementType: "geometry",
  stylers: [{
    color: "#2c5a71"
  }]
}, {
  featureType: "landscape.man_made",
  elementType: "geometry",
  stylers: [{
    visibility: "on"
  }, {
    hue: "#00abff"
  }, {
    lightness: "-32"
  }, {
    weight: "4"
  }, {
    gamma: "1.27"
  }]
}, {
  featureType: "landscape.man_made",
  elementType: "geometry.stroke",
  stylers: [{
    hue: "#00a4ff"
  }, {
    visibility: "on"
  }, {
    lightness: "-53"
  }, {
    gamma: "0.69"
  }, {
    saturation: "13"
  }]
}, {
  featureType: "landscape.man_made",
  elementType: "labels.text.fill",
  stylers: [{
    visibility: "off"
  }, {
    hue: "#ff0000"
  }]
}, {
  featureType: "poi",
  elementType: "geometry",
  stylers: [{
    color: "#406d80"
  }]
}, {
  featureType: "poi.park",
  elementType: "geometry",
  stylers: [{
    color: "#2c5a71"
  }]
}, {
  featureType: "road",
  elementType: "geometry",
  stylers: [{
    color: "#29768a"
  }, {
    lightness: -37
  }]
}, {
  featureType: "transit",
  elementType: "geometry",
  stylers: [{
    color: "#406d80"
  }]
}, {
  featureType: "water",
  elementType: "geometry",
  stylers: [{
    color: "#193341"
  }]
}];
const retroMapStyles = showLabels => [{
  featureType: "all",
  elementType: "labels",
  stylers: [{
    visibility: showLabels || "on"
  }]
}, {
  featureType: "landscape.man_made",
  elementType: "geometry",
  stylers: [{
    color: "#f7f1df"
  }]
}, {
  featureType: "landscape.natural",
  elementType: "geometry",
  stylers: [{
    color: "#d0e3b4"
  }]
}, {
  featureType: "landscape.natural.terrain",
  elementType: "geometry",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.business",
  elementType: "all",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.medical",
  elementType: "geometry",
  stylers: [{
    color: "#fbd3da"
  }]
}, {
  featureType: "poi.park",
  elementType: "geometry",
  stylers: [{
    color: "#bde6ab"
  }]
}, {
  featureType: "road",
  elementType: "geometry.stroke",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "road.highway",
  elementType: "geometry.fill",
  stylers: [{
    color: "#ffe15f"
  }]
}, {
  featureType: "road.highway",
  elementType: "geometry.stroke",
  stylers: [{
    color: "#efd151"
  }]
}, {
  featureType: "road.arterial",
  elementType: "geometry.fill",
  stylers: [{
    color: "#ffffff"
  }]
}, {
  featureType: "road.local",
  elementType: "geometry.fill",
  stylers: [{
    color: "black"
  }]
}, {
  featureType: "transit.station.airport",
  elementType: "geometry.fill",
  stylers: [{
    color: "#cfb2db"
  }]
}, {
  featureType: "water",
  elementType: "geometry",
  stylers: [{
    color: "#a2daf2"
  }]
}];
export const MapStyles = showLabels => ({
  [MapStyle.Standard]: standardMapStyles(showLabels),
  [MapStyle.Dark]: darkMapStyles(showLabels),
  [MapStyle.Light]: lightMapStyles(showLabels),
  [MapStyle.NaturalBlue]: naturalBlueMapStyles(showLabels),
  [MapStyle.Retro]: retroMapStyles(showLabels)
});
//# sourceMappingURL=getMapStyles.js.map